module.exports = __webpack_public_path__ + "img/game_gegame.f869180.webp";